// DashIconsResumenDispachsMinimal.jsx
import React from "react";
import {
  Card,
  Typography,
  Box,
  LinearProgress,
  Grid2,
  Tooltip,
} from "@mui/material";
// 👉 Importa SIEMPRE Grid v2 así:
import LocalPostOfficeIcon from "@mui/icons-material/LocalPostOffice";
import DirectionsBikeIcon from "@mui/icons-material/DirectionsBike";
import WarningIcon from "@mui/icons-material/Warning";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const COLORS = {
  Creadas: "#1E90FF", // Azul
  Ruta: "#591e8f", // Morado
  Incidencias: "#FF0000", // Rojo
  Finalizadas: "#32CD32", // Verde
  Total: "#030303", // Negro
};

const getIcon = (id) => {
  switch (id) {
    case "Creadas":
      return <LocalPostOfficeIcon sx={{ color: COLORS[id] || "#555" }} />;
    case "Ruta":
      return <DirectionsBikeIcon sx={{ color: COLORS[id] || "#555" }} />;
    case "Incidencias":
      return <WarningIcon sx={{ color: COLORS[id] || "#555" }} />;
    case "Finalizadas":
      return <CheckCircleIcon sx={{ color: COLORS[id] || "#555" }} />;
    default:
      return <DirectionsBikeIcon sx={{ color: COLORS[id] || "#555" }} />;
  }
};

const DashIconsResumenDispachsMinimal = ({ items = [], cant = {} }) => {
  const total = Number(cant?.Total) > 0 ? Number(cant.Total) : 0;

  const getPercentage = (value) => {
    const v = Number(value) || 0;
    if (!total) return 0;
    const pct = (v / total) * 100;
    return Number.isFinite(pct) ? Number(pct.toFixed(1)) : 0;
  };

  return (
    <Box sx={{ p: 0.5 }}>
      {/* Grid v2: NO uses `item` en los hijos. Para 5 por fila en md:
          columns md=20 y cada item md=4 -> 20/4 = 5 */}
      <Grid2
        container
        spacing={1}
        justifyContent="flex-end" // ✅ alinear filas a la derecha
        columns={{ xs: 12, sm: 12, md: 20 }}
      >
        {items.map((item) => {
          const color = COLORS[item.id] || "#555";
          const value = Number(cant[item.id]) || 0;
          const pct = getPercentage(value);

          return (
            <Grid2
              key={item.id}
              xs={12}
              sm={6}
              md={4}
              sx={{
                display: "flex", // ✅ el item se vuelve flex
                justifyContent: "flex-end", // ✅ card pegada a la derecha del item
              }}
            >
              <Card
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  p: 1,
                  borderRadius: 2,
                  boxShadow: 2,
                  width: "fit-content",
                  textAlign: "center",
                }}
              >
                <Typography variant="h4" sx={{ fontWeight: 600, color }}>
                  {value}
                </Typography>

                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {item.id}
                </Typography>

                <LinearProgress
                  variant="determinate"
                  value={pct}
                  sx={{
                    width: "80%",
                    height: 6,
                    borderRadius: 3,
                    backgroundColor: "#f1f1f1",
                    "& .MuiLinearProgress-bar": { backgroundColor: color },
                    mt: 1,
                  }}
                />

                <Box sx={{ display: "flex", mt: 1 }}>
                  <Tooltip title={item.id}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: 30,
                        height: 30,
                        borderRadius: "50%",
                        backgroundColor: "#FFF",
                        boxShadow: `0 4px 10px ${color}`,
                        mb: 1,
                      }}
                    >
                      {getIcon(item.id)}
                    </Box>
                  </Tooltip>
                  <Typography variant="caption" sx={{ m: 1, color }}>
                    {pct}%
                  </Typography>
                </Box>
              </Card>
            </Grid2>
          );
        })}
      </Grid2>
    </Box>
  );
};

export default DashIconsResumenDispachsMinimal;
